import { useKeyboardShortcutTogglePlay } from "@/common/hooks/useKeyboardShortcutTogglePlay"
import { useKeyboardShortcutPlayNextTrack } from "@/common/hooks/useKeyboardShortcutPlayNextTrack"
import { useKeyboardShortcutPlayPreviousTrack } from "@/common/hooks/useKeyboardShortcutPlayPreviousTrack"
import { useKeyboardShortcutFastRewind } from "@/common/hooks/useKeyboardShortcutFastRewind"
import { useKeyboardShortcutFastForward } from "@/common/hooks/useKeyboardShortcutFastForward"
import { usePlayerMediaSession } from "@/common/hooks/usePlayerMediaSession"
import { useKeyboardShortcutOpenTrackInfoModal } from "@/common/hooks/useKeyboardShortcutOpenTrackInfoModal";
import { useKeyboardShortcutToggleThemeMode } from "@/common/hooks/useKeyboardShortcutToggleThemeMode.ts";
import useUserEventPlayingTrack from "@/common/hooks/useUserEventPlayingTrack.ts";
import { useKeyboardShortcutEditTrack } from "@/common/hooks/useKeyboardShortcutEditTrack.ts";
import { useKeyboardShortcutCreateFolder } from "@/common/hooks/useKeyboardShortcutCreateFolder.ts";
import { useDocumentContextMenuDefaultPrevented } from "@/common/hooks/useDocumentContextMenuDefaultPrevented.ts";
import useKeyboardShortcutVolumeControl from "@/common/hooks/useKeyboardShortcutVolumeControl.ts";
import useKeyboardShortcutAmplitudeScaleSliderVisible
  from "@/common/hooks/useKeyboardShortcutAmplitudeScaleSliderVisible.ts";
import useSetCurrentTimeFromUrlSearchParam from "@/common/hooks/useSetCurrentTimeFromUrlSearchParam.ts";
import { useKeyboardShortcutOpenTrackViewModal } from "@/common/hooks/useKeyboardShortcutOpenTrackViewModal.ts";

export function useGlobalHooks() {
  // useSetPageTitle()
  usePlayerMediaSession()
  useUserEventPlayingTrack()
  useDocumentContextMenuDefaultPrevented()

  useKeyboardShortcutToggleThemeMode()
  useKeyboardShortcutVolumeControl()
  useKeyboardShortcutEditTrack()
  useKeyboardShortcutPlayNextTrack()
  useKeyboardShortcutAmplitudeScaleSliderVisible()
  useKeyboardShortcutPlayPreviousTrack()
  useKeyboardShortcutOpenTrackViewModal()
  useKeyboardShortcutOpenTrackInfoModal()
  useKeyboardShortcutCreateFolder()
  useKeyboardShortcutTogglePlay()
  useKeyboardShortcutFastRewind()
  useKeyboardShortcutFastForward()
  useSetCurrentTimeFromUrlSearchParam()

  return null
}
